import React, { Component } from 'react';
import _ from 'lodash';

import '../styles/WorkoutStats.css';
import lineGraph from '../assets/icons8-combo-chart-40.png';
import barbell from '../assets/icons8-dumbbell-40.png';

const addVals = (obj) => {
  let starter = 0;
  _.flatMap(obj, (val) => {
    starter += val; 
  });

  return starter;
}

class WorkoutStats extends Component {
  constructor(props){
    super(props);

    this.state = {
      stats: 3
    }

    this.splitWorkout = this.splitWorkout.bind(this);
    this.trimTitle = this.trimTitle.bind(this);
    this.trimDesc = this.trimDesc.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps.workoutObj.movement_stats);
  }

  splitWorkout(workoutArray) {


    if(this.props.amountOfWorkouts === 2) {
      // console.log(workoutArray);
      if(workoutArray.length > 15) {
        let display = workoutArray.slice(0, 8);
        display.push('...')
        return (<div className="tl mw6 center">
          {display.map((row, idx) => 
            <p className="mv0 f4" key={idx}>{row}</p>
          )}
        </div>)
      } else {
        return (<div className="tl mw6 center">
          {workoutArray.map((row, idx) => 
            <p className="mv0 f4" key={idx}>{row}</p>
          )}
        </div>)
      }
    } 

    if(workoutArray.length > 5) {

      let firstHalf = workoutArray.slice(0, Math.ceil(workoutArray.length / 2));
      let secondHalf = workoutArray.slice(Math.ceil(workoutArray.length / 2), workoutArray.length);
      
      if(workoutArray.length > 8 && this.props.amountOfWorkouts > 1) {
        firstHalf = workoutArray.slice(0, 4);
        secondHalf = workoutArray.slice(4, 7);
        secondHalf.push('...');
      } else if(workoutArray.length > 20 && this.props.amountOfWorkouts === 1) {
        firstHalf = workoutArray.slice(0, 10);
        secondHalf = workoutArray.slice(10, 19);
        secondHalf.push('...');
      }

      return(
        <div className="flex mw7 center">
          <div className="w-50 pr2 tl">
            {firstHalf.map((row, idx) => 
              <p className="mv0 f5" key={idx}>{row}</p>
            )}
          </div>
          <div className="w-50 pl2 tl">
            {secondHalf.map((row, idx) => 
              <p className={'mv0 f5' + (row === '...' ? ' tc' : '')} key={idx}>{row}</p>
            )}
          </div>
        </div>
      ) 
    }

    // if none of the conditionals are met, return default
    return (<div className="tl mw6 center">
      {workoutArray.map((row, idx) => 
        <p className="mv0 f5" key={idx}>{row}</p>
      )}
    </div>)
  }

  trimTitle(string) {
    if(this.props.amountOfWorkouts > 2) {
      if(string.length > 28) {
        return string.slice(0, 28) + '...'
      }
      return string;
    }
    return string;
  }

  trimDesc(string) {
    if(this.props.amountOfWorkouts > 2) {
      if(string.length > 38) {
        return string.slice(0, 38) + '...'
      }
      return string;
    }
    return string;
  }

  render() {

    if(!this.props.workoutObj) return(<div>No workouts registered for this track</div>);
    if(!this.props.workoutObj.title && !this.props.workoutObj.workout_name) return(<div className="workout-wrapper absolute top-50 transformY--50 ph3 pv2 w-100 tc"><h2 className="f2">No workouts for your selected tracks!</h2></div>);

    return(
      <div 
        className="workout-wrapper absolute top-50 transformY--50 ph3 pv2 w-100 tc"
        style={{
          minHeight: this.props.minHeight + 'px'
        }}>
        <div className="workout-half">
          <h1 className="title relative flex mt0 mb2 b tc justify-center items-center">
            <div className="numbering mr2 br-100 w2 h2">{this.props.workoutIdx + 1}</div> 
            <div className="dib mr3">{this.props.workoutObj.title ? this.trimTitle(this.props.workoutObj.title) : this.trimTitle(this.props.workoutObj.workout_name)}</div>
          </h1>
          {(this.props.workoutObj.workout_description) &&
            <div>

              {(this.props.workoutObj.workout_name && this.props.workoutObj.title ) &&
                <h3 className="mt3 mb2">{this.trimDesc(this.props.workoutObj.workout_name)}</h3> 
              }
              <div>
                {this.splitWorkout(this.props.workoutObj.workout_description.split('\n'))}
              </div>
            </div>
          }
          {(this.props.workoutObj.notes) &&
            <div>
              <h3 className="mt3 mb2">{this.props.workoutObj.workout_name}</h3>
              <div>
                {this.props.workoutObj.notes.split('\n').map((row, idx) =>
                  <p className="mv0 f5" key={idx}>{row}</p>
                )}
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default WorkoutStats;


// WEBPACK FOOTER //
// ./src/components/WorkoutStats.js